import { withSafeSuspense } from '@calendly/safe-suspense';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { lazy, forwardRef } from 'react';
const loadChunk = async () => {
  const loaded = await import(/* webpackChunkName: 'paymentCard' */'./payment_card');
  return {
    default: loaded.PaymentCard
  };
};
const PaymentCard = lazy(loadChunk);
const PaymentCardWithSuspense = withSafeSuspense(PaymentCard);
const wrapperIsPhoneCss = "w1n2njm5";
const wrapperCss = "w1dm51ka";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const PaymentPage = () => <Wrapper>
    <PaymentCardWithSuspense />
  </Wrapper>;

require("./payment_page.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./payment_page.js");